import { BoxV2 as Box } from 'portal-commons';
import { FunctionComponent } from 'react';

import MnoExclusionRow from './MnoExclusionRow';
import { ExcludedMno } from '@/apis/core/types';

interface MnoExclusionsProps {
  mnos?: ExcludedMno[];
  onRemove?: (mno: ExcludedMno) => void;
}

const Title: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      width: '100%',
      paddingBottom: '3px',
      color: 't.black70',
      fontWeight: 600,
      fontSize: 'H400',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const MnoExclusions: FunctionComponent<MnoExclusionsProps> = ({
  mnos = [],
  onRemove,
}) => {
  return (
    <Box>
      <Title>MNO Exclusions</Title>
      {mnos.map((mno) => (
        <MnoExclusionRow mno={mno} onRemove={() => onRemove?.(mno)} />
      ))}
    </Box>
  );
};

export default MnoExclusions;
